import API from 'api/helpers/client';
import type {
  PrometrixAddressSearchRequest,
  PrometrixBuildingInfo,
  PrometrixEstimatedReplacementCost,
  PrometrixEstimatedReplacementCostRequest,
} from './prometrix.types';

export const getBuildingInfo = async (
  body: PrometrixAddressSearchRequest,
): Promise<PrometrixBuildingInfo> => {
  const { data } = await API.post('prometrix/get_building_info', body);

  return data ?? {};
};

export const getEstimatedReplacementCost = async (
  body: PrometrixEstimatedReplacementCostRequest,
): Promise<PrometrixEstimatedReplacementCost> => {
  const { data } = await API.post('prometrix/estimated_replacement_cost', body);

  return data ?? {};
};
